import React, { FunctionComponent, useEffect } from 'react';
import SearchCarContext from '../context/SearchCarContext';
import useSearchCar from '../hooks/queries/useSearchCar';
import useUrlSearchParams from '../hooks/useUrlSearchParams';
import { UrlSearchParamType } from '../enum/UrlSearchParamType';

const SearchCarContextProvider: FunctionComponent = ({ children }) => {
  const { loading, error, data, loadSearchCar } = useSearchCar();
  const { syncUrlSearchParams, getUrlSearchParams } = useUrlSearchParams();
  const { carCode } = getUrlSearchParams();

  useEffect(() => {
    if (!carCode && !loading) {
      const cancelRequest = loadSearchCar(({ data }) => {
        syncUrlSearchParams({
          [UrlSearchParamType.CAR_CODE]: data?.searchCar,
        });
      });

      return () => {
        if (carCode) {
          cancelRequest();
        }
      };
    }
  }, [carCode, syncUrlSearchParams, loading]);

  return (
    <SearchCarContext.Provider
      value={{
        searchCar: carCode ?? data?.searchCar,
        error,
        loading,
        loadSearchCar,
      }}
    >
      {children}
    </SearchCarContext.Provider>
  );
};

export default SearchCarContextProvider;
